import { vendor } from "./vendor";

export const settings = {
	title: "Editar configuración",
	error: "Sin permiso para editar local",
	alterImage: "Imagen cambiada con éxito",
	attention: "¡Atención!",
	url: "nombredelproducto",
	daysAndWorkingPeriod: "Días y horario de funcionamiento",
	address: {
		postalCode: "Código Postal",
		state: "Estado",
		city: "Ciudad",
		neighborhood: "Colonia",
		address: "Dirección",
		number: "Número",
		complement: "Complemento",
	},
	workingPeriod: {
		deletedPeriod: "Período eliminado.",
		addDaysAndTime: "Agregar días y horarios",
		addOpeningHours: "Agregar horario de funcionamiento",
		daysOfTheWeek: "Días de la semana",
		start: "Inicio",
		end: "Final",
	},
	menu: {
		title: "Otras opciones de configuración",
		general: {
			title: "Generales",
			subtitle: "Informe límites, correos y otros",
		},
		productsWeb: {
			title: "Productos Web",
			subtitle: "Configure la vinculación de bar para delivery.",
		},
		record: {
			title: "Configuración de Fichas",
			subtitle: "Configure el modo ficha",
		},
		couvert: {
			title: "Cover",
			subtitle: "Establezca el valor de cover",
		},
		features: {
			title: "Funcionalidades",
			subtitle: "Active las funcionalidades deseadas",
		},
		pdv: {
			title: "PDV",
			subtitle: "Configure el punto de venta",
		},
		vendor: {
			title: "Vendor",
			subtitle: "Configure información general",
		},
		totem: {
			title: "Tótem",
			subtitle: "Personalizar un tótem",
		},
		refundReason: {
			title: "Motivos de Reembolso/Cancelación",
			subtitle: "Configure motivos para el PDV",
		},
		fiscalPrinter: {
			title: "Impresoras fiscales",
			subtitle: "Configure las impresoras fiscales",
		},
	},
	productsWeb: {
		title: "Productos Web",
		subtitle: "Configure el enlace y demás información de Entrega y Pedido en Mesa.",
		saveChanges: "Guardar cambios",
		toastSuccess: "Configuraciones guardadas con éxito",
		toastError: "No fue posible guardar las configuraciones. Intente nuevamente.",
		tabMenuPersonalization: "Personalización de menú",
		tabFichaDigital: "Ficha Digital",
		fichaDigital: {
			heading: "Visualización de eventos en el menú",
			subtitle: "¿Qué eventos deben aparecer en este menú?",
			sameDayLabel: "Mostrar solo eventos de este día",
			sameDayDescription:
				"Muestra solo los eventos que ocurren en la misma fecha del menú.",
			samePlaceLabel: "Mostrar todos los eventos de este local (place)",
			samePlaceDescription:
				"También muestra eventos de otras fechas vinculados al mismo local.",
			save: "Guardar Cambios",
			saving: "Guardando...",
			toastSuccess: "Configuración guardada con éxito",
			toastError: "No fue posible guardar la configuración",
		},
		tabs: {
			personalization: "Personalización de menú",
			banners: "Banners",
			featured: "Destacados",
		},
		personalizationTab: {
			displayTitle: "Visualización",
			displayDescription:
				"Controle qué secciones aparecen para los clientes en los menús digitales.",
			showBanners: "Mostrar banners",
		},
		featuredTab: {
			title: "Sección destacada",
			description:
				"Arme la sugerencia del día del menú digital: elija el título, active la sección y organice los productos destacados en el orden que desee.",
			titleFieldLabel: "Título de la sección",
			titleFieldPlaceholder: "Ej.: Sugerencias del día",
			titleFieldHelper: "Aparece como encabezado de la sección en el menú.",
			visibilityToggle: {
				label: "Mostrar sección destacada",
				description: "Muestra la sección destacada en el menú digital.",
			},
			disabledNotice: {
				title: "Sección desactivada",
				description:
					"La sección destacada no aparece en el menú. Sus cambios quedan guardados para cuando la reactive.",
			},
			productsFieldLabel: "Productos destacados",
			productsFieldDescription:
				"Agregue productos y arrástrelos para definir el orden de visualización.",
			productsPlaceholder: "Buscar un producto para agregar...",
			productsSearchTooShort: "Escriba al menos 2 caracteres para buscar.",
			productsSearchLoading: "Buscando productos...",
			productsSearchEmpty: "No se encontraron productos.",
			productAdded: "Agregado",
			emptyTitle: "Aún no hay productos destacados",
			emptyDescription:
				"Busque arriba y agregue los productos que aparecerán en la sección destacada.",
			reorderProduct: "Reordenar producto",
			removeProduct: "Quitar producto",
			save: "Guardar cambios",
			saving: "Guardando...",
			toastSuccess: "Sección destacada guardada con éxito",
			toastError: "No fue posible guardar la sección destacada. Intente nuevamente.",
			noMenuTitle: "No se encontró ningún menú digital",
			noMenuDescription: "Cree un menú digital para configurar la sección destacada.",
			languages: {
				ptBR: "Portugués",
				enUs: "Inglés",
				esMx: "Español",
			},
		},
		bannersTab: {
			title: "Banners de campaña",
			description:
				"Cree y organice los banners que se muestran en la parte superior y entre las secciones del menú digital. Arrastre para reordenar.",
			visibilityToggle: {
				label: "Mostrar banners",
				description: "Muestra los banners de campaña en el menú.",
				toastSuccess: "Visibilidad de banners actualizada",
				toastError: "No fue posible actualizar la visibilidad de los banners",
			},
			addBanner: "Agregar banner",
			empty: {
				title: "Ningún banner creado",
				description:
					"Cree banners de campaña para destacar promociones y novedades en el menú digital.",
				action: "Agregar banner",
			},
			slots: {
				hero: "Parte superior (destacado)",
				between_sections: "Entre secciones",
			},
			status: {
				active: "Activo",
				inactive: "Inactivo",
			},
			card: {
				noTitle: "Sin título",
				edit: "Editar banner",
				delete: "Eliminar banner",
				dragHint: "Arrastre para reordenar",
			},
			form: {
				createTitle: "Agregar banner",
				editTitle: "Editar banner",
				image: "Imagen",
				imageHint: "Recomendamos 1280x720 (proporción 16:9), en formatos .PNG o .JPEG.",
				imageRequired: "La imagen es obligatoria.",
				title: "Título",
				titlePlaceholder: "Ej.: Combo de verano",
				subtitle: "Subtítulo",
				subtitlePlaceholder: "Ej.: Pide ya y disfruta",
				linkUrl: "Enlace",
				linkUrlPlaceholder: "https://...",
				slot: "Posición",
				slotHero: "Parte superior (destacado)",
				slotBetweenSections: "Entre secciones",
				targetType: "Direccionamiento",
				targetNone: "Ninguno",
				targetProduct: "Producto",
				targetCategory: "Categoría",
				targetProductPlaceholder: "Seleccione el producto",
				targetCategoryPlaceholder: "Seleccione la categoría",
				startsAt: "Inicio",
				endsAt: "Fin",
				isActive: "Banner activo",
				cancel: "Cancelar",
				save: "Guardar",
				create: "Agregar",
				discardTitle: "¿Descartar cambios?",
				discardDescription:
					"Este banner tiene cambios sin guardar. Si sale ahora, se perderán.",
				discardCancel: "Continuar editando",
				discardConfirm: "Descartar",
			},
			delete: {
				title: "Eliminar banner",
				descriptionPrefix: "¿Está seguro de que desea eliminar el banner ",
				descriptionSuffix: "? Esta acción no se puede deshacer.",
				fallbackName: "sin título",
				cancel: "Cancelar",
				confirm: "Eliminar",
			},
			toast: {
				createSuccess: "Banner creado con éxito",
				editSuccess: "Banner actualizado con éxito",
				deleteSuccess: "Banner eliminado con éxito",
				reorderSuccess: "Orden de los banners actualizado",
				error: "No fue posible completar la acción. Intente nuevamente.",
			},
		},
		qrcodeTab: {
			title: "Código QR",
			description: "Cree los códigos QR de su menú digital aquí.",
			linkCardTitle: "Enlace del menú",
			configureLink: "Configure el slug del menú en Configuración",
			copyLink: "Copiar enlace",
			copySuccess: "Enlace copiado al portapapeles",
			copyError: "No fue posible copiar el enlace",
			generateButton: "Generar código QR",
			drawer: {
				title: "Generar código QR",
				modeSectionTitle: "Modo de creación",
				modeSingle: "Código QR único",
				modeBulk: "Códigos QR en masa",
				singleTitle: "Mesa",
				bulkTitle: "Mesas",
				singleDescription: "Defina la mesa para la cual se generará el código QR.",
				bulkDescription:
					"Defina el rango de mesas. Límite de {{max}} códigos QR por vez.",
				parameterLabel: "Parámetro",
				parameterPlaceholder: "Seleccione un parámetro",
				parameterTooltip: "Tipo de parámetro usado para identificar la mesa.",
				parameterOptions: {
					table: "Mesa",
					chair: "Silla",
					room: "Habitación",
					reference: "Referencia",
				},
				identificationLabels: {
					table: "Identificación de la mesa",
					chair: "Identificación de la silla",
					room: "Identificación de la habitación",
					reference: "Identificación de la referencia",
					default: "Identificación",
				},
				identificationTooltip:
					"Ingrese el identificador para el cual se generará el código QR.",
				identificationPlaceholder: "Ingrese aquí la {{label}}",
				fromLabel: "De",
				fromTooltip: "Primer número de la secuencia.",
				toLabel: "Hasta",
				toTooltip: "Último número de la secuencia.",
				cancel: "Cancelar",
				submit: "Generar código QR",
				successToast:
					"Código(s) QR generado(s) con éxito. La descarga comenzará en breve.",
				errorToast: "Algo salió mal durante la creación, pero puede intentarlo de nuevo",
				validation: {
					alphanumericOnly: "Solo se aceptan letras y números",
					parameterRequired: "Seleccione un parámetro",
					fromRequired: "Indique el inicio del rango",
					toRequired: "Indique el fin del rango",
					toGreaterThanFrom: "Hasta debe ser mayor o igual que De",
					maxQuantity: "Límite máximo de {{max}} códigos QR por vez",
				},
				discardDialog: {
					title: "¿Descartar cambios?",
					description:
						"Tiene cambios sin guardar en este formulario. Si sale ahora, se perderán.",
					cancel: "Seguir editando",
					confirm: "Descartar cambios",
				},
			},
		},
		generalTab: {
			urlLabel: "Dirección URL",
			urlSubtitle:
				"Defina la dirección URL de acceso para el Menú digital, Entrega, Pedido en Mesa y Comanda Online.",
			slugInvalid: "El slug debe contener solo letras, números, guiones y guiones bajos",
			barLabel: "Bar para impresión",
			barSubtitle:
				"Vincule las integraciones a un bar de seguridad. Si algún pedido no se imprime en el bar configurado de la integración, se envía a este bar.",
			selectBarLabel: "Seleccione el bar",
			selectBarTooltip: "Solo es posible vincular un bar para todas las integraciones",
			noInternalIpAlert: {
				message:
					"El bar seleccionado no tiene IP interno configurado. Los pedidos pueden no imprimirse automáticamente.",
			},
		},
	},
	warningDialog:
		"Está habilitando pagos post-pagos en '{{name}}'. " +
		"¿Está seguro de esto? Para confirmar la modificación, " +
		"favor ingrese '{{text}}'",
	data: {
		label: "Datos",
		name: "Nombre",
		selectProduct: "Seleccione un producto para habilitar depósito caución automático",
		noneProduct: "Ningún producto",
		peopleCapacity: "Capacidad máxima",
		slug: "Slug",
		peopleCapacityTooltip: "Cantidad de personas que el local puede albergar.",
	},
	passTemplate: "ID del modelo del pase",
	limits: {
		label: "Límites y servicios",
		postPaidLimit: "Límite de post-pago",
		serviceTax: "Tasa de servicio",
		rechargeNotIntegratedLimit: "Límite de recarga no integrada",
		nonIntegratedPaymentLimit: "Límite de pago no integrado por device y evento",
		enableBuiltInLimit: "Activar límite de recarga no integrada",
		enableNonIntegratedPaymentLimit:
			"Activar límite de pago no integrado por device y evento",
		nonIntegratedPaymentLimitTooltip:
			"Este límite se refiere al valor máximo de pagos no integrados " +
			"que un dispositivo puede recibir durante el evento. Este parámetro es la suma " +
			"del total de Recargas y Ventas Sin Tarjeta hechos con pagos no integrados.",
		nonIntegratedRechargeLimitTooltip:
			"Este límite se refiere al valor máximo que un empleado puede hacer en una recarga no integrada.",
	},
	settings: {
		label: "Configuración",
		myActionsPassword: {
			label: "Contraseña de 'Mis acciones'",
			placeholder:
				"Ingrese una contraseña numérica o la contraseña predeterminada será 9090",
		},
		sellVisualizationFormat: {
			label: "Formato de visualización de los productos en la venta",
			grid: "Cuadrícula",
			list: "Lista",
		},
		kdsServer: {
			label: "IP del servidor KDS",
			placeholder: "Escriba la IP",
		},
	},
	everest: {
		label: "Everest",
		user: "Usuario",
		password: "Contraseña",
		cnpj: "CNPJ",
		host: "Host",
	},
	placeFeatures: "Funcionalidades",
	email: "Correos para recepción del cierre de los eventos",
	emailError: "Correo inválido",
	consumption: {
		label: "Configuración fiscal de consumo mínimo",
		fiscalProfile: "Perfil fiscal",
		fiscalGroup: "Grupo fiscal",
		ncm: "NCM",
	},
	alert: "Se realizaron modificaciones, guarde para mantenerlas",
	save: "Guardar",
	saveSettings: "Guardar configuración",
	image: "Foto",
	ficha: {
		label: "Ficha",
		text: "Título de la Ficha",
		placeholderText: "Ingrese el título de la ficha",
		logo: "Imagen en la ficha",
		upload: "Adjuntar imagen",
		formatError: "Formato no soportado",
		imageFormatMessage: "Es necesario que la imagen sea un PNG o SVG.",
		recommendationMessage:
			"Recomendamos que la imagen asignada sea el <strong>logo</strong> de la empresa en <strong>color negro</strong>, ya que no es posible realizar la impresión de otro color.",
		dragOrSelectMessage:
			"Arrastre la imagen de la computadora o seleccione a partir de 'Adjuntar imagen'.",
		logoFormatMessage:
			"Es necesario que el <strong>fondo de la imagen/logo esté blanco</strong>, para que quede transparente en la impresión.",
		dimensionsMessage:
			"Las dimensiones sugeridas para una buena resolución son las de <strong>472x472</strong> px.",
	},
	couvertEdit: {
		label: "Editar covers",
		editCouvert: "Editar cover",
		newCouvert: "Nuevo cover",
		male: "masculino",
		female: "femenino",
		men: "Hombres",
		women: "Mujeres",
		edit: "Editar",
		add: "Agregar",
		cancel: "Cancelar",
		columns: {
			public: "Público",
			name: "Nombre",
			category: "Categoría",
			price: "Precio",
			fiscalProfile: "Perfil fiscal",
			fiscalProductGroup: "Grupo fiscal",
		},
		alert: {
			title:
				"Al habilitar el modo fiscal, los covers fueron deshabilitados, actualice los datos fiscales de los covers para habilitarlos nuevamente.",
			message:
				"Los datos fiscales de cover son obligatorios para la emisión fiscal. Si aún no tiene datos fiscales de cover, agregue ",
			action: "haciendo clic aquí",
		},
		error: {
			value: {
				required: "Este campo es obligatorio",
				value: "El valor del cover debe ser menor o igual al límite de post-pago",
			},
			name: {
				required: "Nombre es obligatorio",
				maxLength: "Nombre solo puede tener hasta {{maxLength}} caracteres",
			},
			category: {
				required: "Categoría es obligatoria",
				maxLength: "Categoría solo puede tener hasta {{maxLength}} caracteres",
			},
		},
	},
	devices: {
		label: "PDVs del local ({{counter}})",
		placeholder: "Agregar un PDV a este local",
		requestDevices: "Solicitar equipos",
	},
	errors: {
		invalidName: "Ingrese un nombre válido",
		invalidTip: "Ingrese un valor de hasta 25%",
		postPaidLimit: "Ingrese un valor válido",
		rechargeNotIntegratedLimit: "Valor mínimo de",
		hasConsumptionObligation:
			"Campo obligatorio para configuración de obligación de consumo",
		minNonIntegratedPaymentLimit: "Valor mínimo de {{value}}",
		tipOptionsValuesRequired: "Los valores de las propinas son necesarios",
		tipOptionLowerValue: 'El "Valor menor" debe ser menor que los valores medio y mayor',
		tipOptionHigherValue: 'El "Valor mayor" debe ser mayor que el valor medio',
		invalidUrl: "Ingrese una URL válida (https://...)",
	},
	totem: {
		logoSelectDescription:
			"<strong>Seleccione el logo que mejor se aplica en su imagen</strong> (desconsidere el color de fondo)",
		addLogo: "Agregar",
		important: "Importante",
		instructions: "Recomendaciones",
		image:
			"La imagen debe tener las dimensiones de <strong>1080 x 1920</strong> px de altura",
		logo:
			"El logo de <strong>Zig</strong> aparecerá sobre la imagen asignada, centrado en la parte superior",
		recomendations:
			"Se recomienda insertar el mensaje <strong>'toque para iniciar'</strong> para orientar al usuario",
		defaultMessage:
			"Si no agrega una imagen de pantalla inicial, " +
			"la pantalla predeterminada de Zig será su pantalla inicial " +
			"(vea primera imagen en 'Colores')",
		totemImgLabel: "Imagen de la pantalla inicial (opcional)",
		totenCustomizationLabel: "Personalización Tótem Ficha",
		removeTotemImage: {
			title: "¿Desea eliminar la pantalla inicial?",
			content:
				"Al eliminar, la pantalla inicial vuelve a ser la pantalla predeterminada de Zig.",
			confirmBtn: "Sí, quiero eliminar",
			cancelBtn: "No",
		},
		colors: "Colores",
		saveMessage: "Guardar personalización",
	},
	tip: {
		taxType: "Tipo de tasa",
		tip: "Propina",
		tipSuggestions: "Sugerencias de propina",
		serviceTax: "Tasa de servicio",
		none: "Sin tasa",
		lowerValue: "Valor menor",
		medValue: "Valor medio",
		higherValue: "Valor mayor",
		tooltip:
			"Las recomendaciones de propina hacen el pago de cuenta más fácil, " +
			"ofreciendo tres opciones de porcentajes (Menor, Media y Mayor) con base " +
			"en el valor total de la cuenta, por ejemplo: 5%, 10% y 15% limitado a 25%",
	},
	authKeysFeature: {
		phone: "Teléfono",
		email: "Correo electrónico",
		keySelectLabel: "Elija el tipo de clave",
		addKey: "Agregar Claves de autenticación",
		contactsInputLabel: "Agregue una o más claves para autenticación",
		contactsEmailInputPlaceholder: "Ingrese un correo válido (ej: correo@gmail.com)",
		contactsPhoneInputPlaceholder:
			"Ingrese un número de teléfono (ej: +55 (00) 0 00000000",
		btnAddKey: "Agregar claves de autenticación",
		btnCancelAddKey: "Cancelar",
		authKeyAreaTitle: "Autenticación de retiro",
		authKeyAreaSubtitle:
			"Registre claves (correo electrónico o teléfono) que se utilizarán para recibir el código de autenticación al solicitar un retiro.",
		selectContactKeyMessage: "Seleccione un tipo de claves",
		selectContactInputMessage: "Complete una clave de contacto",
		contactAlreadyExists: "¡Este contacto ya existe!",
		invalidEmail: "Correo electrónico inválido",
		invalidPhone: "Teléfono inválido. Debe contener DDI (ej: +5511999999999)",
		incompletePhone: "Número de teléfono incompleto. Ingrese todos los dígitos.",
		invalidDDI:
			"Solo se aceptan números telefónicos brasileños. Use el DDI +55 o déjelo en blanco.",
		errorCreatingAuthKeys: "Error al crear claves de autenticación",
		invalidContactsFound:
			"Se encontraron contactos inválidos. Verifique los datos e intente nuevamente.",
		errorCreatingSomeKeys: "Error al crear algunas claves: {{errors}}",
	},
	vendor,
	invoiceMoment: {
		fieldLabel: "Seleccione el momento para emisión de Factura cashless",
		tip:
			"Seleccione el momento de la emisión de la factura para pagos Cashless. Para todas las otras formas de pago, que no sean Cashless, la factura será siempre emitida en el momento del consumo.",
		recharge: "Recarga",
		rechargeAndActivation: "Recarga y activación",
		consumption: "Consumo",
		consumptionAndActivation: "Consumo y activación",
	},
	refundReason: {
		addReason: "Crear motivo",
		cancel: "Cancelación",
		modalDelete: {
			confirmation: "¿Desea eliminar de la lista de motivos de reembolsos y cancelación?",
			description:
				"Al eliminar el motivo no aparecerá más, pero permanecerá en los informes antiguos.",
			title: "Eliminar motivo de reembolso/cancelación",
		},
		modalForm: {
			addReason: "Crear Motivo",
			allowOpenText: "Habilitar justificación",
			creatingReason: "Creando un motivo",
			editReason: "Guardar cambios",
			editingReason: "Editando un motivo",
			reason: "Motivo",
			reasonPlaceholder: "Ingrese el motivo de reembolso y/o cancelación",
		},
		reason: "Motivo",
		removeReason: "Editar motivo",
		refund: "Reembolso",
		table: {
			cancel: "Cancelación",
			editReason: "Editar motivo",
			observation: "Observación",
			reason: "Motivo",
			refund: "Reembolso",
			removeReason: "Eliminar motivo",
			status: "Estado",
		},
		title: "Motivos de Reembolso/Cancelación",
	},
	fiscalPrinter: {
		title: "Impresoras fiscales",
		name: "Nombre",
		type: "Tipo",
		ip: "Ip",
		actions: "Acciones",
		deletedSuccessfully: "Impresora eliminada con éxito",
		addedSuccessfully: "Impresora agregada con éxito",
	},
	defaultDateFilter: "Filtro de fecha predeterminado",
	pageHeader: {
		title: "Configuraciones generales",
		description:
			"Agregue información sobre su establecimiento que se mostrará a los clientes finales",
	},
	sections: {
		comingSoon: "Próximamente",
		brand: {
			title: "Información de la marca",
			description:
				"Agregue información de la marca como logo, nombre y slug (enlace URL). Esta información será pública y se mostrará en los menús digitales.",
			addPhoto: "Agregar foto",
			fileHint: "Tipo de archivo PNG o JPEG.",
		},
		payments: {
			title: "Pagos y Tarifas",
			description: "Informe los límites de pago, tasas de propina y otros.",
		},
		socialMedia: {
			title: "Redes Sociales",
			description:
				"Mostraremos sus redes sociales en la información del establecimiento en los menús digitales.",
			titleTooltip: "Copie y pegue el enlace de las redes sociales del establecimiento",
			facebookLabel: "Facebook",
			instagramLabel: "Instagram",
			linkPlaceholder: "Pegue el enlace del perfil del establecimiento",
		},
		workingHours: {
			title: "Horario de funcionamiento",
			description:
				"Los días y horarios de funcionamiento del establecimiento se mostrarán en el menú digital cuando estén definidos.",
		},
		event: {
			title: "Información para evento",
			description:
				"Informe el correo de contacto del establecimiento, número de teléfono y capacidad máxima del establecimiento.",
			emailLabel: "Correos para recibir el cierre de eventos",
		},
		address: {
			title: "Dirección del establecimiento",
			description:
				"Defina la dirección del establecimiento; se mostrará en la información del establecimiento en los menús digitales.",
		},
	},
};
